// import React from 'react';
// import {
//     MDBCard,
//     MDBCardBody,
//     MDBCardTitle,
//     MDBBtn,
//     MDBInput,
//     MDBIcon,
//     MDBContainer,
// } from "mdb-react-ui-kit";
// import "../css/imgbanner.css";

// const IMGBanner = ({ BannerTitle }) => {
//     return (
//         <MDBContainer fluid className='p-0'>
//             <header>
//                 <div
//                     className='p-5 text-center bg-image'
//                     style={{
//                         backgroundImage: BannerTitle.img,
//                         minHeight: "500px",
//                         backgroundPosition: "top",
//                         backgroundRepeat: "repeat",
//                         backgroundPositionX: '75%',
//                         backgroundPositionY: '25%'
//                     }}
//                 >
//                     <div className="col-md-12 col-lg-6 p-3 text-light text-start imgbanner" style={{ backgroundColor: "rgba(103, 25, 185, 0.5)", borderRadius: '10px' }}>
//                         <div style={{ fontFamily: 'Alegreya Sans', fontSize: '2.5rem', lineHeight: '1.2', marginBottom: '0.5rem', }}>
//                             {BannerTitle.title}
//                         </div>
//                         <p className="head-para" style={{ fontSize: '26px', fontFamily: 'Alegreya Sans' }}>
//                             {BannerTitle.subtitle}
//                         </p>
//                     </div>
//                     <div class="col-md-12 col-lg-6 mt-md-10 mt-sm-5 form ">

//                     </div>
//                 </div>
//             </header>
//         </MDBContainer>
//     );
// };
// export default IMGBanner;

import React from 'react';
import {
  MDBContainer,
} from "mdb-react-ui-kit";
import "../css/imgbanner.css";
import mbs from  "../../src/img/medicalbillingservices/CodingServices/Blogimage.jpg"
import RCMcy from '../img/Denail_Management.jpg';

const IMGBanner = ({ BannerTitle }) => {
  // Identify specific image to apply special background position
  const isSpecificImage = BannerTitle.img.includes(mbs); // Replace with your image filename
 const isSpecificImage1 = BannerTitle.img.includes(RCMcy);
  return (
    <MDBContainer fluid className='p-0'>
      <header>
        <div
          className={`p-5 text-center bg-image ${isSpecificImage ? 'focus-specific-img' : ''}`}
          style={{
            backgroundImage: BannerTitle.img,
            minHeight: "500px",
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover",
            backgroundPositionX: isSpecificImage ? '35%' : 'center',
    backgroundPositionY: isSpecificImage ? '90%' : 'center'
          }}
          
          
          
        >

          <div
            className="col-md-12 col-lg-6 p-3 text-light text-start imgbanner"
            style={{
              backgroundColor: "rgba(103, 25, 185, 0.5)",
              borderRadius: '10px'
            }}
          >
            <div
              style={{
                fontFamily: 'Alegreya Sans',
                fontSize: '2.5rem',
                lineHeight: '1.2',
                marginBottom: '0.5rem',
              }}
            >
              {BannerTitle.title}
            </div>
            <p
              className="head-para"
              style={{
                fontSize: '26px',
                fontFamily: 'Alegreya Sans'
              }}
            >
              {BannerTitle.subtitle}
            </p>
          </div>

          <div className="col-md-12 col-lg-6 mt-md-10 mt-sm-5 form">
            {/* Optional form section */}
          </div>
        </div>
      </header>
    </MDBContainer>
  );
};

export default IMGBanner;
